<template>
    <div class="customer-invite-form">
        <h2>Invite New Customer</h2>
        <b-form @submit.prevent="handleSubmit" :validated="validated" novalidate>
            <b-form-group
                id="phone-group"
                label="Phone Number"
                :state="!formErrors.has('phone_number')"
                :invalid-feedback="formErrors.first('phone_number')"
            >
                <vue-tel-input
                    :class="formErrors.has('phone_number') ? 'error-input' : ''"
                    v-model="formFields.phone_number"
                    @focus="resetError"
                    @input="onPhoneInput"
                ></vue-tel-input>
                <b-form-invalid-feedback :state="!formErrors.has('phone')">
                    {{ formErrors.first('phone') }}
                </b-form-invalid-feedback>
            </b-form-group>

            <div class="d-flex gap-2 mt-4">
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="isSubmitting"
                >
                    <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
                    {{ isSubmitting ? 'Sending Invite...' : 'Send Customer Invite' }}
                </b-button>
                <b-button variant="secondary" @click="cancel">Cancel</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import Error from "@/Util/Error";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import axios from "@/axios";

const FORM_STATE = {
    phone_number: ''
};

export default {
    name: 'CustomerInviteForm',
    components: {
        VueTelInput
    },
    data() {
        return {
            formFields: { ...FORM_STATE },
            formErrors: new Error({}),
            validated: false,
            isSubmitting: false,
            phone: {
                inputValue: ''
            },
            country_code: '',
        }
    },
    methods: {
        resetError() {
            this.formErrors = new Error({});
        },
        onPhoneInput(formattedNumber, input) {
            this.phone.inputValue = input?.nationalNumber || '';
            if (input && input.nationalNumber) {
                setTimeout(() => {
                    if (formattedNumber.startsWith('+61')) {
                        input.countryCallingCode = 61;
                        input.countryCode = 'AU';
                    }
                    this.formFields.phone_number = input?.nationalNumber || '';
                    this.country_code = `+${input.countryCallingCode}`;
                }, 0);
            }
        },
        async removeError(key) {
            if (typeof key === 'object') {
                for (let i = 0; i < key.length; i++) {
                    this.formErrors.remove(key[i]);
                }
            } else {
                this.formErrors.remove(key);
            }
        },
        cancel() {
            this.$router.back();
        },
        async handleSubmit() {
            try {
                this.validated = true;
                this.isSubmitting = true;
                this.formErrors = new Error({});

                // Validate phone
                const phoneRegex = /^\d{6,15}$/;
                if (!this.formFields.phone_number || !phoneRegex.test(this.formFields.phone_number)) {
                    this.formErrors.errors.phone_number = ['Phone number must be 6-15 digits'];
                    return;
                }

                const response = await axios.post('/admin/customer-invites', {
                    phone: this.country_code+this.formFields.phone_number
                });

                if (response.status === 201) {
                    this.resetForm();
                    this.$emit('invite-sent', true);
                } else {
                    this.formErrors = new Error(response.errors || {});
                }
            } catch (error) {
                if (error.request && error.request.status === 422) {
                    const responseData = JSON.parse(error.request.responseText);
                    this.formErrors = new Error(responseData.errors || {});
                } else {
                    this.$emit('invite-error', error.message || 'An error occurred while sending the invite');
                }
            } finally {
                this.isSubmitting = false;
            }
        },
        resetForm() {
            this.formFields = { ...FORM_STATE };
            this.formErrors = new Error({});
            this.validated = false;
        }
    }
}
</script>

<style scoped>
.customer-invite-form {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
}

.form-group {
    margin-bottom: 20px;
}

h2 {
    margin-bottom: 1.5rem;
    color: #2c3e50;
    font-size: 2rem;
}

.error-input {
    border-color: #dc3545 !important;
}

:deep(.vue-tel-input) {
    border-radius: 0.25rem;
    border: 1px solid #ced4da;
}

:deep(.vue-tel-input.error-input) {
    border-color: #dc3545 !important;
}

:deep(.vue-tel-input:focus-within) {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

:deep(.vue-tel-input.error-input:focus-within) {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
</style>
